import {Task} from '../../../../_shared/model';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import 'rxjs';
import {HttpClientService} from '../../../../_shared/services/http-client.service';
import {HelperService, StorageService} from '../../../../_shared/services';

@Injectable()
export class TaskService {
    constructor(private httpClient: HttpClientService, private helper: HelperService) {}

    public concludeTask(contractorId: number, taskId: number): Observable<Task[]> {
        return this.httpClient.put(this.helper.getTaskUrl() + '/contractors/' + contractorId + '/tasks/' + taskId, {
            responseType: 'text',
        });
    }

    public getContractorTasks(contractorId: number, viewConcluded?: boolean): Observable<Task[]> {
        return this.httpClient.get(
            this.helper.getTaskUrl() + '/contractors/' + contractorId + '/tasks?concluded=' + (viewConcluded || false),
            {
                responseType: 'json',
            },
        );
    }
}
